/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SbRespFollowSearchBanner_user$ref = any;
type SbSharedFollowSearchProvider_user$ref = any;
export type SbRespNullSearchResults_user$ref = any;
export type SbRespNullSearchResults_user = {
    readonly " $fragmentRefs": SbRespFollowSearchBanner_user$ref & SbSharedFollowSearchProvider_user$ref;
    readonly " $refType": SbRespNullSearchResults_user$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SbRespNullSearchResults_user",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "SbRespFollowSearchBanner_user",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "SbSharedFollowSearchProvider_user",
            "args": null
        }
    ]
} as any);
(node as any).hash = '1b80459e049e9b30d9d27099e75dfee0';
export default node;
